import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Html from './Html';

import styles from '../../../styles/partials/body.module.scss';

const propTypes = {
    className: PropTypes.string,
    body: PropTypes.string,
};

const defaultProps = {
    className: null,
    body: null,
};

const Body = ({ className, body }) => {
    if (body === null) {
        return null;
    }

    return (
        <Html
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            body={body}
        />
    );
};

Body.propTypes = propTypes;
Body.defaultProps = defaultProps;

export default Body;
